import { apiClient } from './client';
import { BulletinAttachment, BulletinPage, BulletinPost, BulletinPostPayload } from '../types/bulletin';

export async function fetchBulletins(params?: {
  keyword?: string;
  mine?: boolean;
  page?: number;
  size?: number;
}): Promise<BulletinPage> {
  const { data } = await apiClient.get<BulletinPage>('/bulletins', {
    params: {
      ...(params?.keyword?.trim() ? { q: params.keyword.trim() } : {}),
      ...(params?.mine ? { mine: true } : {}),
      page: params?.page ?? 0,
      size: params?.size ?? 20,
    },
  });
  return data;
}

export async function fetchBulletin(postId: number): Promise<BulletinPost> {
  const { data } = await apiClient.get<BulletinPost>(`/bulletins/${postId}`);
  return data;
}

export async function createBulletin(payload: BulletinPostPayload): Promise<BulletinPost> {
  const { data } = await apiClient.post<BulletinPost>('/bulletins', payload);
  return data;
}

export async function updateBulletin(
  postId: number,
  payload: Partial<BulletinPostPayload>
): Promise<BulletinPost> {
  const { data } = await apiClient.patch<BulletinPost>(`/bulletins/${postId}`, payload);
  return data;
}

export async function deleteBulletin(postId: number): Promise<void> {
  await apiClient.delete(`/bulletins/${postId}`);
}

export async function uploadBulletinAttachments(
  postId: number,
  files: File[]
): Promise<BulletinAttachment[]> {
  const formData = new FormData();
  files.forEach((file) => formData.append('files', file));
  const { data } = await apiClient.post<BulletinAttachment[]>(
    `/bulletins/${postId}/attachments`,
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' } }
  );
  return data;
}

export async function deleteBulletinAttachment(postId: number, attachmentId: number): Promise<void> {
  await apiClient.delete(`/bulletins/${postId}/attachments/${attachmentId}`);
}

export async function downloadBulletinAttachment(
  postId: number,
  attachmentId: number,
  fileName: string
): Promise<void> {
  const { data } = await apiClient.get<Blob>(
    `/bulletins/${postId}/attachments/${attachmentId}/download`,
    { responseType: 'blob' }
  );
  const url = window.URL.createObjectURL(data);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = fileName;
  anchor.click();
  window.URL.revokeObjectURL(url);
}
